
export function truncate(value, limit) {
  return value ? value.length > limit ? value.substring(0, limit) + '...' : value : value;
}
export function string2literal (value){
  var maps = {
   "NaN": NaN,
   "null": null,
   "undefined": undefined,
   "Invalid date": null
   }
  return ((value in maps) ? maps[value] : value);
}

export function bytesToBase64(bytes) {
  const binString = String.fromCodePoint(...bytes);
  return window.btoa(binString);
}
